import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Loader } from '@sdir/sds';
import { CardRow, Card } from '../../Atoms';
import { useCurrentPerson } from '../../../services/hooks';

const ContactInfoSummaryCard: React.FC = () => {
  const intl = useIntl();
  const {
    person: { loading, result: contactInfo },
  } = useCurrentPerson();

  const name = useMemo(() => {
    let personName = '';
    if (contactInfo?.firstName) personName += `${contactInfo?.firstName} `;
    if (contactInfo?.middleName) personName += `${contactInfo?.middleName} `;
    if (contactInfo?.lastName) personName += `${contactInfo?.lastName}`;
    return personName;
  }, [contactInfo?.firstName, contactInfo?.lastName, contactInfo?.middleName]);

  return (
    <Card heading={intl.formatMessage({ id: 'newapp.steps.contactinfo' })}>
      {loading ? (
        <Loader />
      ) : (
        <>
          <CardRow
            label={intl.formatMessage({
              id: 'contactinfo.navn',
            })}
          >
            {name}
          </CardRow>
          <CardRow
            label={intl.formatMessage({
              id: 'contactinfo.email',
            })}
          >
            {contactInfo?.email}
          </CardRow>
          <CardRow
            label={intl.formatMessage({
              id: 'contactinfo.phone',
            })}
          >
            {contactInfo?.phoneNumber}
          </CardRow>
        </>
      )}
    </Card>
  );
};

export default ContactInfoSummaryCard;
